import React from "react";

import { Label, Small } from "@fronterahealth/frontera-ui-components";

import { EhrStoredFieldPartsFragment } from "@api/graphql/types-and-hooks";
import { StoredHtml } from "@pages/ClientEhrProgramming/StoredHtml";
import { looksLikeHtml } from "@pages/ClientEhrProgramming/looksLikeHtml";

export interface EhrStoredRow {
  id: string;
  fields: EhrStoredFieldPartsFragment[];
}

interface EhrStoredRowTableProps {
  rows: EhrStoredRow[];
}

// Columns are the union of every row's field keys, in first-seen order, so rows with
// extra columns (e.g. a linked session) still line up.
export const EhrStoredRowTable: React.FC<EhrStoredRowTableProps> = ({ rows }) => {
  const columns = new Set<string>();
  rows.forEach((row) => row.fields.forEach((field) => columns.add(field.key)));

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full text-left">
        <thead>
          <tr className="border-b border-limestone-200">
            {[...columns].map((key) => (
              <th key={key} className="px-3 py-2 align-bottom whitespace-nowrap">
                <Label size="small">{key}</Label>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => {
            const valueByKey = new Map(row.fields.map((field) => [field.key, field.value]));
            return (
              <tr key={row.id} className="border-b border-limestone-100 align-top">
                {[...columns].map((key) => {
                  const value = valueByKey.get(key);
                  return (
                    <td key={key} className="px-3 py-2">
                      {value && looksLikeHtml(value) ? (
                        <StoredHtml html={value} className="text-xs" />
                      ) : (
                        <Small className={value ? "whitespace-pre-wrap" : "text-text-secondary"}>{value || "––"}</Small>
                      )}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
